import { Inject, Injectable, Optional } from '@angular/core';
import {
  APP_MAIN_ICON,
  APP_SHORT_NAME,
  APP_MAIN_ICON_FONT_SET
} from '@pcplus/core';
import { Observable, ReplaySubject } from 'rxjs';
import {
  SHOW_MENU_OBSERVABLE,
  AVAILABLE_SOUNDS,
  DISABLE_NOTIFICATIONS
} from '../../tokens';
import { HeaderItem } from './header-item';
import { SoundDefinition } from './sound-definition';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  constructor(
    @Inject(SHOW_MENU_OBSERVABLE) public showMenu$: Observable<boolean>,
    @Inject(APP_SHORT_NAME) public appShortName: string,
    @Inject(APP_MAIN_ICON) public mainIcon: string,
    @Inject(APP_MAIN_ICON_FONT_SET) public mainIconFontSet: string,
    @Inject(AVAILABLE_SOUNDS) public availableSounds: SoundDefinition[],
    @Optional()
    @Inject(DISABLE_NOTIFICATIONS)
    public disableNotifications: boolean
  ) {}

  private _addItem$ = new ReplaySubject<HeaderItem>();
  private _removeItem$ = new ReplaySubject<string | null>();

  get addItem$(): Observable<HeaderItem> {
    return this._addItem$.asObservable();
  }

  get removeItem$(): Observable<string | null> {
    return this._removeItem$.asObservable();
  }

  addItem(item: HeaderItem) {
    this._addItem$.next(item);
  }

  removeItem(id: string | null) {
    this._removeItem$.next(id);
  }
}
